import { UNAUTHORIZED_PAGES } from 'common/enums';
import { useTypedSelector } from 'hooks/use-typed-selector';
import { useComponent } from 'hooks/use-component';
import { User } from 'common/interfaces';

export const useReportDamageCustomLink = () => {
  const user = useTypedSelector<User>(state => state.app.user);
  const { getIsDisplayComponent } = useComponent();

  const isCustomDamageReportLinkAvailable = getIsDisplayComponent('customDamageReportLink', { showByDefault: false });

  const getLink = () => {
    if (isCustomDamageReportLinkAvailable && user.schadenmeldenLink) {
      return user.schadenmeldenLink;
    }

    return UNAUTHORIZED_PAGES.REPORT_DAMAGE;
  };

  return { reportDamageCustomLink: getLink() };
};
